import type { ProjetoEtapa } from '../../../types';

export interface EtapaConfig {
  valor: ProjetoEtapa;
  rotulo: string;
  /** Cor de fundo/texto do badge (classes Tailwind). */
  badge: string;
  /** Cor sólida da bolinha do stepper e da barra de progresso. */
  cor: string;
}

/**
 * Ordem do fluxo normal. `pausado` e `cancelado` ficam fora porque não são etapas de avanço —
 * são desvios, e colocá-los na régua daria a impressão de que o projeto "progrediu" ao ser
 * cancelado.
 */
export const ETAPAS_FLUXO: EtapaConfig[] = [
  { valor: 'planejamento', rotulo: 'Planejamento', badge: 'bg-slate-100 text-slate-700 dark:bg-slate-500/20 dark:text-slate-300', cor: '#94a3b8' },
  { valor: 'em_execucao', rotulo: 'Em execução', badge: 'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300', cor: '#d4a017' },
  { valor: 'em_teste', rotulo: 'Em teste', badge: 'bg-sky-100 text-sky-700 dark:bg-sky-500/20 dark:text-sky-300', cor: '#0ea5e9' },
  { valor: 'concluido', rotulo: 'Concluído', badge: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300', cor: '#10b981' },
];

export const ETAPAS_DESVIO: EtapaConfig[] = [
  { valor: 'pausado', rotulo: 'Pausado', badge: 'bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300', cor: '#f97316' },
  { valor: 'cancelado', rotulo: 'Cancelado', badge: 'bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300', cor: '#f43f5e' },
];

export const TODAS_ETAPAS: EtapaConfig[] = [...ETAPAS_FLUXO, ...ETAPAS_DESVIO];

export const configDaEtapa = (etapa: ProjetoEtapa): EtapaConfig =>
  TODAS_ETAPAS.find(e => e.valor === etapa) || ETAPAS_FLUXO[0];

/** Índice na régua do fluxo; -1 para pausado/cancelado, que não estão na régua. */
export const indiceDaEtapa = (etapa: ProjetoEtapa): number =>
  ETAPAS_FLUXO.findIndex(e => e.valor === etapa);
